export const getRepositoryFullnameFromMatch = (match) => {
    const { owner, repository, subrepository } = match.params;
    const fullname = `${owner}/${repository}` + (subrepository ? '/' + subrepository : '');
    return fullname;
};
